import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=template&id=1515bb64&lang=html&"
import script from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=script&lang=js&"
export * from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=script&lang=js&"
import style0 from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCardTitle,VCheckbox,VCol,VForm,VRadio,VRadioGroup,VRow,VSelect,VSpacer,VSwitch,VTextField})
